var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyAlbum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7983 66.6641C36.7115 67.2788 36.6666 67.9069 36.6666 68.5456C36.6666 75.9094 42.6361 81.8789 49.9999 81.8789C57.3637 81.8789 63.3332 75.9094 63.3332 68.5456C63.3332 67.9069 63.2883 67.2788 63.2015 66.6641H95.5554V96.3234C95.5554 98.1643 94.0631 99.6567 92.2221 99.6567H7.77767C5.93672 99.6567 4.44434 98.1643 4.44434 96.3234V66.6641H36.7983Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4443 67.7765C64.4443 75.7539 57.9773 82.2209 49.9999 82.2209C42.0224 82.2209 35.5554 75.7539 35.5554 67.7765C35.5554 67.518 35.5622 67.2612 35.5756 67.0061H4.44434L15.067 35.5974C15.525 34.2434 16.7953 33.332 18.2247 33.332H81.7751C83.2045 33.332 84.4748 34.2434 84.9327 35.5974L95.5554 67.0061H64.4241C64.4375 67.2612 64.4443 67.518 64.4443 67.7765Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3306 68.841C62.3306 75.0054 56.81 81.1137 50 81.1137C43.19 81.1137 37.6694 75.0054 37.6694 68.841C37.6694 68.6413 37.6752 67.3317 37.6866 67.1346H14.4445L23.5126 45.0865C23.9036 44.0402 24.9879 43.3359 26.2082 43.3359H73.7919C75.0121 43.3359 76.0965 44.0402 76.4874 45.0865L85.5556 67.1346H62.3134C62.3248 67.3317 62.3306 68.6413 62.3306 68.841Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3306 68.841C62.3306 75.0054 56.81 81.1137 50 81.1137C43.19 81.1137 37.6694 75.0054 37.6694 68.841C37.6694 68.6413 37.6752 67.3317 37.6866 67.1346H14.4445L23.5126 45.0865C23.9036 44.0402 24.9879 43.3359 26.2082 43.3359H73.7919C75.0121 43.3359 76.0965 44.0402 76.4874 45.0865L85.5556 67.1346H62.3134C62.3248 67.3317 62.3306 68.6413 62.3306 68.841Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83313 67.2324V96.6632C5.83313 97.7371 6.70369 98.6076 7.77757 98.6076H92.222C93.2959 98.6076 94.1665 97.7371 94.1665 96.6632V67.2324L83.617 36.0402C83.3498 35.2504 82.6088 34.7188 81.775 34.7188H18.2246C17.3908 34.7188 16.6498 35.2504 16.3826 36.0402L5.83313 67.2324Z",
    stroke: "#999999",
    strokeWidth: 4.27083
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 66.6641C24.3739 66.6641 29.0942 66.6641 34.161 66.6641C36.2457 66.6641 36.2457 68.1291 36.2457 68.8863C36.2457 76.2501 42.3526 82.2196 49.8858 82.2196C57.419 82.2196 63.5259 76.2501 63.5259 68.8863C63.5259 68.1291 63.5259 66.6641 65.6106 66.6641H93.3333M11.7485 66.6641H14.4444H11.7485Z",
    stroke: "#999999",
    strokeWidth: 4.27083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8883 8.11675L65.5554 21.9536M48.9994 3.33594V21.9536V3.33594ZM19.9999 8.11675L32.3328 21.9536L19.9999 8.11675Z",
    stroke: "#999999",
    strokeWidth: 4.27083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAlbum);
export default __webpack_public_path__ + "static/media/empty_album.72719b9459bff7fc46163e5d0071f7ac.svg";
export { ForwardRef as ReactComponent };